<template>
  <div>
    <sidebar></sidebar>
    <div class="page-container">
      <topbar></topbar>

      <main class='main-content bgc-grey-100'>
        <div id='mainContent'>
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12">
                <div class="bgc-white bd bdrs-3 p-20">
                  <h4 class="c-grey-900 mT-10 mB-30">Dashboard</h4>

<div class="masonry-item col-md-12">
    <div class="bgc-white p-20 bd">
        <h6 class="c-grey-900">Work order status</h6>
        <div class="mT-30">
            <div class="peers mT-20 fxw-nw@lg+ jc-sb ta-c gap-10">
                <div class="peer">
                    <div class="easy-pie-chart" data-size="80" data-percent="15" data-color="#f44336"><span>15%</span></div>
                    <h6 class="fsz-sm">Unassigned</h6></div>
                <div class="peer">
                    <div class="easy-pie-chart" data-size="80" data-percent="35" data-color="#ffc107"><span>35%</span></div>
                    <h6 class="fsz-sm">Assigned</h6></div>
                <div class="peer">
                    <div class="easy-pie-chart" data-size="80" data-percent="50" data-color="#4caf50"><span>50%</span></div>
                    <h6 class="fsz-sm">Completed</h6></div>
            </div>
        </div>
    </div>
</div>


<div class="masonry-item col-md-12">
<div class="bgc-white p-20 bd">
<h6 class="c-grey-900">Unassigned / Completed</h6>
<div class="mT-30">
<canvas id="line-chart" height="220"></canvas>
</div>
</div>
</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <footerbar></footerbar>
    </div>
  </div>
</template>

<script>
import Sidebar from './sidebar';
import Topbar from './topbar';
import Footerbar from './footerbar';
import axios from 'axios';
import { getIdToken} from '../../utils/auth';

import EasyPieChart from 'easy-pie-chart';
import Char from 'chart.js';

const items = []

export default {
  name: 'dashboard',
  mounted() {

var element = document.querySelectorAll('.easy-pie-chart');
element.forEach(function(element2) {
new EasyPieChart(element2, {
barColor: element2.dataset.color
});
});



  const lineChartBox = document.getElementById('line-chart');

  if (lineChartBox) {
    const lineCtx = lineChartBox.getContext('2d');
    lineChartBox.height = 80;

    new Chart(lineCtx, {
      type: 'line',
      data: {
        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
        datasets: [{
          label                : 'Unsassigned',
          backgroundColor      : 'rgba(237, 231, 246, 0.5)',
          borderColor          : '#f44336',
          pointBackgroundColor : '#e53935',
          borderWidth          : 2,
          data                 : [60, 50, 70, 60, 50, 70, 60],
        }, {
          label                : 'Completed',
          backgroundColor      : 'rgba(232, 245, 233, 0.5)',
          borderColor          : '#4caf50',
          pointBackgroundColor : '#388e3c',
          borderWidth          : 2,
          data                 : [70, 75, 85, 70, 75, 85, 70],
        }],
      },

      options: {
        legend: {
          display: false,
        },
      },

    });
  }




    this.getUserList();
  },
  data() {
    return {

      items: items,

      fields: [ {
          key: 'name',
          sortable: true
        },
        {
          key: 'email',
          sortable: false
        },
      ],

      currentPage: 1,
      perPage: 5,
      totalRows: items.length,
      pageOptions: [ 5, 10, 15 ],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      modalInfo: { title: '', content: '' },
    }
  },
  methods: {
    getUserList() {
      const self = this;
      const token = getIdToken();
      const authstr = 'Bearer '.concat(token);

      axios.get('https://portal.procmanager.com/rest/user/users', { headers: {'Authorization': authstr } } )
        .then(response => {
           this.items = response.data.users;
        })
        .catch(error => { })
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    }
  },
  components: {
    'sidebar': Sidebar,
    'topbar': Topbar,
    'footerbar': Footerbar
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dashboard.vue